export enum QueueType {
  ALERT_QUEUE = 'ALERT_QUEUE',
  CASE_QUEUE = 'CASE_QUEUE',
  SAR_QUEUE = 'SAR_QUEUE',
}

export enum QueueAccessType {
  OPEN = 'OPEN',
  RESTRICTED = 'RESTRICTED',
  CLASSIFIED = 'CLASSIFIED',
}

export enum QueueAssignmentType {
  TEAMS = 'TEAMS',
  SCHEDULE = 'SCHEDULE',
}

export enum DeadlineState {
  LATE = 'Overdue',
  WARNING = 'Approaching deadline',
  OKAY = 'In progress',
  NO_DEADLINE = 'No deadline set',
}

export enum QueueSortTypes {
  HIGHEST_TRANSACTION_VALUE = 'HIGHEST_TRANSACTION_VALUE',
  OLDEST_CREATION_DATE = 'OLDEST_CREATION_DATE',
}

export enum QueueSubtypes {
  TM = 'TM',
  CAR = 'CAR',
  CHAINALYSIS = 'CHAINALYSIS',
  DARK_WEB = 'DARK_WEB',
  CTR = 'CTR',
  TRM = 'TRM',
}

export enum QueueOwningTeamAvailability {
  ALL_TEAMS = 'ALL_TEAMS',
  RESTRICT_BY_TEAM = 'RESTRICT_BY_TEAM',
}

export enum QueueCalcStartDate {
  ENTERED_QUEUE_AT = 'ENTERED_QUEUE_AT',
  CASE_START_DATE = 'CASE_START_DATE',
}

export const QUEUE_CALC_START_DATE_GLOBAL = 'GLOBAL' as const;

export type CaseQueueDeadlineFormType =
  | `${QueueCalcStartDate}`
  | typeof QUEUE_CALC_START_DATE_GLOBAL;

export interface ChartStack {
  name: DeadlineState;
  data: number[];
}

export interface SeriesPoint {
  x: DeadlineState;
  y: number;
}
